<template>
  <div>
    <search-form
      :fetchData="fetch"
      ref="searchFormRef"
      :handelSearch="handelSearch"
      :handelAdd="showAddModal"
      :collection="formCollection"
      :ableSearch="ableSearch"
      :resetWillRequest="true"
      @reset="handelSearch"
      :ableAdd="ableAdd"
    ></search-form>
    <a-modal
      width="700px"
      v-model:open="open"
      :title="(isEdit ? '编辑' : '新增') + pageName"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
      class="action-form-model-small"
    >
      <action
        :v-if="open"
        @submit="clickOk"
        :isEdit="isEdit"
        :editData="editData"
        :data="tableData"
        :idField="idField"
      ></action>
    </a-modal>
    <!-- 详情弹窗 -->
    <a-modal
      width="800px"
      v-model:open="detailModalVisible"
      title="车辆标记详情"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
    >
      <div v-if="detailData" class="detail-container">
        <a-descriptions bordered :column="1" :size="'middle'">
          <a-descriptions-item label="车牌号码">{{ detailData.license_plate }}</a-descriptions-item>
          <a-descriptions-item label="车型">{{ codeToText(detailData.vehicle_type_id, store.state.common.carModel) }}</a-descriptions-item>
          <a-descriptions-item label="来访单位">{{ detailData.visitor_company }}</a-descriptions-item>
          <a-descriptions-item label="标记颜色">{{ codeToText(detailData.color_id, store.state.common.labelColor) }}</a-descriptions-item>
          <a-descriptions-item label="标记类型">{{ codeToText(detailData.label_type_id, store.state.common.labelType) }}</a-descriptions-item>
          <a-descriptions-item label="告警类型">{{ codeToText(detailData.alarm_id, store.state.common.labelAlarmType) }}</a-descriptions-item>
          <a-descriptions-item label="状态">{{ codeToText(detailData.status, store.state.common.labelStatus) }}</a-descriptions-item>
          <a-descriptions-item label="标记原因">{{ detailData.remark }}</a-descriptions-item>
          <a-descriptions-item label="取消理由" v-if="detailData.cancel_reason">{{ detailData.cancel_reason }}</a-descriptions-item>
          <a-descriptions-item label="创建人">{{ detailData.create_user_id }}</a-descriptions-item>
          <a-descriptions-item label="修改人">{{ detailData.update_user_id || '-' }}</a-descriptions-item>
          <a-descriptions-item label="创建时间">{{ detailData.create_time }}</a-descriptions-item>
          <a-descriptions-item label="更新时间">{{ detailData.update_time }}</a-descriptions-item>
        </a-descriptions>
        
        <!-- 标记车辆现场图片 -->
        <div class="detail-section" v-if="markImageList.length > 0">
          <h4 class="section-title">标记车辆现场图片</h4>
          <ImagePreview :model-value="markImageList" width="150" />
        </div>
        
        <!-- 取消标记材料图片 -->
        <div class="detail-section" v-if="cancelImageList.length > 0">
          <h4 class="section-title">取消标记材料图片</h4>
          <ImagePreview :model-value="cancelImageList" width="150" />
        </div>
      </div>
    </a-modal>
    <!-- 取消标记模态框 -->
    <a-modal
      width="600px"
      v-model:open="cancelModalVisible"
      title="取消标记"
      :footer="null"
      :destroyOnClose="true"
      :keyboard="false"
    >
      <a-form
        v-if="cancelModalVisible"
        ref="cancelFormRef"
        :model="cancelFormData"
        :rules="cancelFormRules"
        layout="vertical"
        @finish="handleCancelSubmit"
      >
        <a-form-item label="取消理由" name="cancel_reason">
          <a-textarea
            v-model:value="cancelFormData.cancel_reason"
            placeholder="请输入取消理由"
            rows="4"
          />
        </a-form-item>
        <a-form-item label="整改报告图片" name="cancel_photo">
            <ImgUpload
              v-model="cancelFormData.cancel_photo"
              field="cancel_photo"
              :number="9"
              :required="true"
            />
          </a-form-item>
        <a-form-item>
          <div style="text-align: right;">
            <a-button @click="cancelModalVisible = false" style="margin-right: 8px;">取消</a-button>
            <a-button type="primary" html-type="submit" :loading="submitting">确定</a-button>
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
    <a-table
      :columns="columns"
      :row-key="(record) => record.uuid"
      :data-source="tableData"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
      :scroll="{x: 'max-content'}"
    >
      <template #bodyCell="{ column, record, index }">
        <template v-if="column.key === 'rowIndex'">
          {{ index + 1 }}
        </template>
        <template v-if="column.key === 'action'">
          <span>
            <a-button
              @click="showDetailModal(record)"
              :loading="loadingRecord === record"
            >
              详情
            </a-button>
            <a-button
              v-if="ableEdit && record.status === 1"
              @click="showEditModal(record)"
              :loading="loadingRecord === record"
            >
              编辑
            </a-button>
            <a-button
              v-if="ableCancel && record.status === 1"
              @click="showCancelModal(record)"
              :loading="loadingRecord === record"
              danger
            >
              取消
            </a-button>
            <a-popconfirm
              title="确认删除？"
              ok-text="确认"
              cancel-text="取消"
              @confirm="delRow(record)"
              v-if="ableDelete"
            >
              <a-button danger>删除</a-button>
            </a-popconfirm>
          </span>
        </template>
        <table_data_format
          v-else
          :record="record"
          :column="column"
        ></table_data_format>
      </template>
    </a-table>
  </div>
</template>
<script setup>
import { ref, onMounted, toRefs, computed } from 'vue'
import { getData, deleteData, cancelData, detailData as detailDataApi } from '@/api/car_application/car_mark'
import action from './action'
import { useStore } from 'vuex'
import { message } from 'ant-design-vue'
import searchForm from '@/components/search_form'
import table_data_format from '@/components/table_data_format'
import { UploadOutlined } from '@ant-design/icons-vue'
import ImgUpload from '@/components/form/img_upload'
import ImagePreview from '@/components/form/image_preview'
import { baseURL } from '@/config'
import { constantToOptions, codeToText } from '@/utils/format'
import { gender } from '@/utils/common'

  //初始化
  const pageName = '车辆标记'
  const idField = 'id' //响应数据的id的字段名
  const store = useStore()

  const permissionList = computed(() => store.getters['user/permissionList'])
  const ableSearch = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carMark:list')
  )
  const ableAdd = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carMark:add')
  )
  const ableEdit = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carMark:edit')
  )
  const ableCancel = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carMark:cancel')
  )
  const ableDelete = computed(() =>
    !!permissionList.value?.find(item => item.code === 'carMark:delete')
  )

  //1、搜索框
  const formCollection = [
    {
      type: 'input',
      field: 'license_plate',
      label: '车牌号码',
    },
    {
      type: 'input',
      field: 'visitor_company',
      label: '来访单位',
    },
    {
      type: 'select',
      field: 'status',
      storeOptions: 'labelStatus',
      label: '状态',
      defaultValue: -1,
      width: '130px',
    },
    {
      type: 'select',
      field: 'color_id',
      storeOptions: 'labelColor',
      label: '标记颜色',
      defaultValue: -1,
      width: '130px',
    },
    {
      type: 'select',
      field: 'label_type_id',
      storeOptions: 'labelType',
      label: '标记类型',
      defaultValue: -1,
      width: '130px',
    },
    {
      type: 'select',
      field: 'alarm_id',
      storeOptions: 'labelAlarmType',
      label: '告警类型',
      defaultValue: -1,
      width: '130px',
    },
  ]
  const searchFormRef = ref()
  function handelSearch() {
    pagination.value.current = 1
    fetch()
    const params = {
      ...searchFormRef.value.formState
    }
    store.commit('search/setCarMark', params)
  }

  //2、表格
  const columns = [
    {
      title: '序号',
      dataIndex: 'rowIndex',
      key: 'rowIndex',
      align: 'center',
      width: 50,
      fixed: 'left',
    },
    {
      title: '车牌号码',
      dataIndex: 'license_plate',
      key: 'license_plate',
      align: 'left',
    },
    {
      title: '车型',
      dataIndex: 'vehicle_type_name',
      key: 'vehicle_type_name',
      align: 'left',
    },
    {
      title: '来访单位',
      dataIndex: 'visitor_company',
      key: 'visitor_company',
      align: 'left',
      width: 180,
    },
    {
      title: '标记原因',
      dataIndex: 'remark',
      key: 'remark',
      align: 'left',
      width: 200,
    },
    {
      title: '标记颜色',
      key: 'color_id',
      align: 'left',
    },
    {
      title: '标记类型',
      key: 'label_type_id',
      align: 'left',
    },
    {
      title: '告警类型',
      key: 'label_alarm_id',
      align: 'left',
    },

    {
      title: '状态',
      key: 'label_status',
      align: 'left',
    },
    {
      title: '取消理由',
      dataIndex: 'cancel_reason',
      key: 'cancel_reason',
      align: 'left',
      width: 200,
    },
    {
      title: '创建人',
      dataIndex: 'create_user_id',
      key: 'create_user_id',
      align: 'left',
    },
    {
      title: '修改人',
      dataIndex: 'update_user_id',
      key: 'update_user_id',
      align: 'left',
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      align: 'left',
    },
    {
      title: '更新时间',
      dataIndex: 'update_time',
      key: 'update_time',
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      align: 'left',
      fixed: 'right',
      // width: '200px',
    },
  ]

  const tableData = ref([])
  const loading = ref(false)
  const loadingRecord = ref()
  const pagination = ref({
    current: 1,
    pageSize: 10,
    showLessItems: true,
    showQuickJumper: true,
    showSizeChanger: true,
    showTotal: (total, range) => {
      return `共 ${total} 条`
    },
  })

  function handleTableChange(page) {
    pagination.value = { ...pagination.value, ...page }
    fetch()
  }

  function fetch() {
    //获取表单值
    const formState = searchFormRef.value?.formState

    loading.value = true
    getData({
      size: pagination.value.pageSize,
      pn: pagination.value.current,
      ...formState,
    }).then(({ data }) => {
      loading.value = false
      tableData.value = data.list
      pagination.value.total = data.total
    })
  }
  
  const cachedSearchParams = computed(() => store.state.search.searchCarMark)
  onMounted(() => {
    for (const key in cachedSearchParams.value) {
      searchFormRef.value.formState[key] = cachedSearchParams.value[key]
    }
    fetch()
  })

  //3、编辑、添加
  const open = ref(false)
  const isEdit = ref(false)
  const editData = ref(null)

  const showAddModal = () => {
    editData.value = null
    isEdit.value = false
    open.value = true
  }

  const showEditModal = async (record) => {
    try {
      const res = await detailDataApi({ id: record[idField] })
      if (res.success) {
        res.data.photo = res.data.files?.filter(f => f.type === 1)?.map(f => f.url)
        console.log(res.data.photo, 'photo')
        editData.value = res.data
        isEdit.value = true
        open.value = true
        // 处理图片列表
        // processDetailImages(res.data)
      } else {
        message.warn('获取详情失败：' + res.message)
      }
    } catch (error) {
      message.error('获取详情失败，请重试')
    } finally {
      loadingRecord.value = null
    }

    // data.photo = data.files?.filter(f => f.type === 1)?.map(f => f.url)
    
    // editData.value = record
    // isEdit.value = true
    // open.value = true
  }

  function clickOk() {
    fetch()
    handleOk()
    clearEditData()
  }

  const handleOk = () => {
    open.value = false
  }
  const clearEditData = () => {
    editData.value = null
  }

  //4、取消标记
  const cancelModalVisible = ref(false)
  const currentCancelRecord = ref(null)
  const cancelFormRef = ref()
  const submitting = ref(false)
  
  const cancelFormData = ref({
      cancel_reason: '',
      cancel_photo: []
    })
    
    // 详情相关
    const detailModalVisible = ref(false)
    const detailData = ref(null)
    const markImageList = ref([])
    const cancelImageList = ref([])
  
  const cancelFormRules = {
    cancel_reason: [
      { required: true, message: '请输入取消理由', trigger: 'blur' }
    ],
    // cancel_photo: [
    //   {
    //     required: true,
    //     message: '请上传整改报告图片',
    //     trigger: 'change'
    //   }
    // ]
  }

  const showCancelModal = (record) => {
    currentCancelRecord.value = record
    cancelFormData.value = {
      cancel_reason: '',
      cancel_photo: []
    }
    cancelModalVisible.value = true
  }

  const handleCancelSubmit = async () => {
    if (!currentCancelRecord.value) return
    
    try {
      submitting.value = true
      loadingRecord.value = currentCancelRecord.value
      console.log(cancelFormData.value, 'eee')
      const params = {
        id: currentCancelRecord.value[idField],
        cancel_reason: cancelFormData.value.cancel_reason,
        cancel_photo: cancelFormData.value.cancel_photo
      }
      
      const res = await cancelData(params)
      if (res.success) {
        message.success('取消成功！')
        fetch()
        cancelModalVisible.value = false
      } else {
        message.warn('取消失败：' + res.message)
      }
    } catch (error) {
      message.error('操作失败，请重试')
    } finally {
      submitting.value = false
      loadingRecord.value = null
      currentCancelRecord.value = null
    }
  }

  //4、删除
  async function delRow(data) {
    const res = await deleteData({ id: data[idField] })
    if (res.success) {
      message.success('删除成功！')
      fetch()
    } else {
      message.warn('删除失败' + res.message)
    }
  }
  
  // 显示详情弹窗
  const showDetailModal = async (record) => {
    loadingRecord.value = record
    try {
      const res = await detailDataApi({ id: record[idField] })
      if (res.success) {
        detailData.value = res.data
        // 处理图片列表
        processDetailImages(res.data)
        detailModalVisible.value = true
      } else {
        message.warn('获取详情失败：' + res.message)
      }
    } catch (error) {
      message.error('获取详情失败，请重试')
    } finally {
      loadingRecord.value = null
    }
  }
  
  // 处理详情中的图片
  const processDetailImages = (data) => {
    // 标记车辆现场图片
    const markImages = []
    if (data.photo) {
      markImages.push(data.photo)
    }
    // 从files中提取标记类型为1的图片
    if (data.files && Array.isArray(data.files)) {
      data.files.forEach(file => {
        if (file.type === 1) {
          markImages.push({ url: file.url })
        }
      })
    }
    markImageList.value = markImages
    
    // 取消标记材料图片
    const cancelImages = []
    if (data.cancel_photo) {
      cancelImages.push(data.cancel_photo)
    }
    // 从files中提取标记类型为2的图片
    if (data.files && Array.isArray(data.files)) {
      data.files.forEach(file => {
        if (file.type === 2) {
          cancelImages.push({ url: file.url })
        }
      })
    }
    cancelImageList.value = cancelImages
  }
</script>
  
  <style scoped>
    .detail-container {
      padding: 16px;
    }
    
    .detail-section {
      margin-top: 24px;
      padding: 16px;
      background-color: #f5f5f5;
      border-radius: 4px;
    }
    
    .section-title {
      margin: 0 0 16px 0;
      font-size: 16px;
      font-weight: 500;
      color: #262626;
    }
    
    :deep(.ant-descriptions-row:not(:last-child)) {
      border-bottom: 1px solid #f0f0f0;
    }
    
    :deep(.ant-descriptions-item-label) {
      font-weight: 500;
    }
  </style>
